import * as React from "react";
import { SVGProps } from "react";

const DownloadFromGooglePlayButton = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox={"0 0 123 38"}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M119 38H4c-2.27 0-4-1.71-4-4V4c0-2.29 1.73-4 4-4h115c2.27 0 4 1.71 4 4v30c0 2.29-1.73 4-4 4Z"
      fill="#000"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.82 19.12V9.132c0-.57.477-1.046.954-1.046s.668.095.954.285L30.13 18.454c.382.19.572.476.572.761 0 .286-.19.57-.572.761L11.728 30.06c-.19.095-.477.285-.954.285-.476 0-.953-.475-.953-1.046V19.12Z"
      fill="url(#a)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.74 19.215 10.583 8.085h.19c.477 0 .668.096.954.286l13.54 7.42-3.529 3.424Z"
      fill="url(#b)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m25.172 22.544-3.432-3.425 3.528-3.52 4.862 2.664c.382.19.573.476.573.761 0 .285-.191.57-.573.761l-4.958 2.759Z"
      fill="url(#c)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.68 30.153 21.74 19.12l3.432 3.425-13.444 7.324c-.286.19-.477.285-1.049.285.095 0 .095 0 0 0Z"
      fill="url(#d)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M68.27 32.722c-.477-.38-.858-1.046-1.049-1.427l1.526-.666c.095.19.286.476.476.761.382.38.954.761 1.526.761.572 0 1.24-.285 1.62-.76.287-.476.478-.952.478-1.618v-.57c-1.144 1.426-3.528 1.236-4.863-.286-1.43-1.522-1.43-4.09 0-5.612 1.43-1.427 3.528-1.617 4.767-.285v-.666h1.621v7.134c0 1.807-.667 2.854-1.525 3.52-.572.475-1.43.665-2.193.665-.858-.095-1.717-.38-2.384-.951Zm39.951.38 1.621-3.804-2.86-6.564h1.62l2.003 4.661 2.002-4.66h1.621l-4.386 10.367h-1.621Zm-7.723-3.614c-.477-.476-.668-1.142-.668-1.807 0-.571.191-1.142.572-1.522.668-.666 1.621-.952 2.67-.952.668 0 1.24.095 1.716.38 0-1.14-.953-1.616-1.716-1.616-.667 0-1.335.38-1.621 1.046l-1.43-.57c.286-.666 1.049-1.903 2.956-1.903.953 0 1.907.285 2.479.951.572.666.763 1.427.763 2.473v3.995h-1.621v-.665c-.191.285-.572.475-.858.666-.382.19-.858.285-1.335.285-.572-.095-1.43-.285-1.907-.761Zm-50.821-3.424c0-1.903 1.43-3.996 4.005-3.996 2.479 0 4.004 2.093 4.004 3.995 0 1.903-1.43 3.996-4.005 3.996-2.574 0-4.004-2.093-4.004-3.995Zm8.581 0c0-1.903 1.43-3.996 4.005-3.996 2.479 0 4.005 2.093 4.005 3.995 0 1.903-1.43 3.996-4.005 3.996-2.48 0-4.005-2.093-4.005-3.995Zm-19.355 2.092c-2.384-2.378-2.289-6.278.095-8.751 1.24-1.237 2.765-1.807 4.386-1.807 1.525 0 3.051.57 4.195 1.712l-1.144 1.236c-1.716-1.712-4.481-1.617-6.102.096a4.588 4.588 0 0 0 0 6.373c1.716 1.807 4.576 1.902 6.293.095.572-.57.763-1.332.858-2.093h-4.005v-1.712h5.626c.095.38.095.856.095 1.332 0 1.427-.572 2.853-1.526 3.805-1.048 1.046-2.574 1.617-4.1 1.617-1.716-.096-3.432-.666-4.671-1.903Zm40.332.666c-1.43-1.522-1.43-4.09 0-5.707 1.43-1.522 3.814-1.522 5.149 0 .477.475.763 1.141 1.049 1.807l-5.245 2.188a2.034 2.034 0 0 0 1.907 1.236c.859 0 1.43-.285 2.003-1.141l1.43.951c-.19.19-.381.38-.477.57-1.62 1.618-4.386 1.618-5.816.096Zm9.916 1.142V19.404h3.433c2.002 0 3.623 1.427 3.623 3.139 0 1.712-1.43 3.139-3.242 3.139h-2.097v4.185H89.15v.096Zm8.01 0V19.404h1.62v10.558h-1.62Zm-21.55-.19V17.977h1.717v11.795h-1.716Zm29.082-2.95c-.381-.285-.953-.38-1.525-.38-1.145 0-1.812.57-1.812 1.237 0 .665.667 1.046 1.335 1.046.953 0 2.002-.761 2.002-1.902Zm-48.819-.76c0-1.142-.762-2.378-2.193-2.378-1.43 0-2.192 1.236-2.192 2.378 0 1.141.762 2.378 2.193 2.378 1.334 0 2.192-1.237 2.192-2.378Zm8.582 0c0-1.142-.763-2.378-2.193-2.378-1.43 0-2.193 1.236-2.193 2.378 0 1.141.763 2.378 2.193 2.378 1.43 0 2.193-1.237 2.193-2.378Zm8.486.665c0-.095 0-.19.095-.285v-.856c0-.095-.095-.286-.095-.38-.286-.952-1.144-1.618-2.002-1.618-1.144 0-2.098 1.142-2.098 2.378 0 1.332.954 2.378 2.193 2.378.763.096 1.526-.57 1.907-1.617Zm6.96-.856 3.528-1.522c-.381-.665-.953-.856-1.43-.856-1.43.095-2.288 1.617-2.097 2.378Zm14.589-3.234c0-.951-.763-1.617-1.812-1.617h-1.907v3.33h2.002c.954 0 1.717-.762 1.717-1.713Z"
      fill="#fff"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M109.461 31.2h-.096v-.095h.096-.096v.096h.096ZM109.651 31.2c0-.095 0-.095 0 0-.095-.095-.095-.095 0 0-.095 0-.095 0 0 0Zm0-.095c0 .096 0 .096 0 0 0 .096-.095.096 0 0 0 0-.095 0 0 0ZM109.747 31.105h-.096.096v.096-.096Z"
      fill="#fff"
    />
    <path
      d="M37.567 10.083c0-1.712 1.24-2.759 2.766-2.759 1.048 0 1.716.476 2.193 1.142l-.763.475c-.286-.38-.763-.666-1.43-.666-1.05 0-1.812.761-1.812 1.903 0 1.141.763 1.902 1.812 1.902.572 0 1.048-.285 1.239-.475v-.856h-1.526v-.856h2.575v1.997c-.477.57-1.24.951-2.193.951-1.621 0-2.86-1.141-2.86-2.758ZM43.765 12.747V7.42h3.623v.856h-2.765v1.332h2.67v.856h-2.67v1.522h2.765v.856l-3.623-.095ZM50.058 12.747V8.276h-1.621V7.42h4.195v.856h-1.62v4.47h-.954ZM55.874 12.747V7.42h.954v5.327h-.954ZM59.402 12.747V8.276h-1.62V7.42h4.195v.856h-1.621v4.47h-.954Z"
      fill="#fff"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M67.793 7.324c-1.621 0-2.765 1.142-2.765 2.759 0 1.522 1.144 2.758 2.765 2.758 1.62 0 2.765-1.141 2.765-2.758s-1.144-2.759-2.765-2.759Zm-.095.856c1.144 0 1.811.761 1.811 1.903 0 1.046-.667 1.902-1.811 1.902-1.145 0-1.812-.76-1.812-1.902 0-1.047.763-1.903 1.812-1.903Z"
      fill="#fff"
    />
    <path
      d="M75.326 12.747 72.56 8.942v3.805h-.953V7.42h.953l2.766 3.71V7.42h.953v5.327h-.953Z"
      fill="#fff"
    />
    <defs>
      <linearGradient
        id="a"
        x1={5.729}
        y1={9.574}
        x2={11.742}
        y2={31.256}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#006884" />
        <stop offset={1} stopColor="#8AD1D0" />
      </linearGradient>
      <linearGradient
        id="b"
        x1={4.303}
        y1={15.352}
        x2={15.949}
        y2={26.287}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#24BBB6" />
        <stop offset={1} stopColor="#DBE692" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={31.095}
        y1={22.943}
        x2={31.095}
        y2={15.382}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FCC072" />
        <stop offset={1} stopColor="#F58A5B" />
      </linearGradient>
      <linearGradient
        id="d"
        x1={19.957}
        y1={36.496}
        x2={27.805}
        y2={22.749}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#712B8F" />
        <stop offset={1} stopColor="#EA1D27" />
      </linearGradient>
    </defs>
  </svg>
);

export default DownloadFromGooglePlayButton;
